<template>
  <input
    type="checkbox"
    class="switcher"
    :disabled="disabled"
    :checked="checked"
    @change="handleChange" />
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    disabled: Boolean,
    checked: Boolean,
  },
  methods: {
    handleChange (e) {
      this.$emit('change', e.target.checked)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/switcher.vue